import { FunctionalComponent, h } from '@stencil/core';

export interface GridProps {
  configuration: keyof typeof validConfigurations;
  valign?: Valign;
}

export const validConfigurations = {
  '3': ['span-3'],
  '2': ['span-2'],
  '5': ['span-5'],
  '2-3': ['span-2', 'span-3'],
  '2-3_desktop': ['span-2', 'span-3 -desktop-only'],
  '3-2': ['span-3', 'span-2'],
  'x-3': ['offset-2 span-3'],
  'x-2': ['offset-3 span-2'],
};

export const enum Valign {
  DEFAULT = '',
  BOTTOM = '-valign-bottom',
}

export const Grid: FunctionalComponent<GridProps> = ({ configuration, valign }, children, utils) => {
  return (
    <rudy-grid configuration={configuration} valign={valign}>
      {utils.map(children, (child, index) => {
        return {
          ...child,
          vattrs: {
            ...child.vattrs,
            class: `${child.vattrs.class} ${validConfigurations[configuration][index] || ''}`,
          },
        };
      })}
    </rudy-grid>
  );
};

export const GridColumn: FunctionalComponent<{}> = ({}, children) => {
  return <div class="">{children}</div>;
};
